import { Box, Tabs as GenericTabs, Tab, useTheme } from '@mui/material';
import PropTypes from 'prop-types';
import { MuiTabsProps } from 'src/types/tabs';

export const Tabs = ({
  activeTab,
  handleTabChange,
  tabs,
  isTransform = true,
}: MuiTabsProps) => {
  const theme: any = useTheme();

  return (
    <Box mb={2}>
      <GenericTabs
        value={activeTab}
        onChange={handleTabChange}
        TabIndicatorProps={{
          style: {
            backgroundColor: theme?.palette ? theme.palette.primary.main : undefined,
          },
        }}
      >
        {tabs.map((tab) => {
          const label =
            isTransform? tab?.label.charAt(0).toUpperCase() + tab?.label.slice(1).toLowerCase() : tab?.label;

          return (
            <Tab
              key={tab.value ?? label}
              label={label}
              value={tab.value}
              style={{
                padding: '0px 20px',
                margin: '0 4px',
                borderRadius: '8px',
                textTransform: 'none',
                minWidth: 'auto',
                color:
                  activeTab === tab.value
                    ? theme.palette.primary.main
                    : theme.palette.text.secondary,
                fontWeight: 600,
                fontSize: '0.75rem',
              }}
            />
          );
        })}
      </GenericTabs>
    </Box>
  );
};

Tabs.propTypes = {
  activeTab: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  handleTabChange: PropTypes.func,
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      content: PropTypes.node,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    })
  ).isRequired,
};
